import React, { useEffect, useState } from "react";
import TSearch from "./type";
import MNPG from "@/components/MainPageLayouts/components/MNPG";
import useMainPageItems from "@/hooks/useMainPageItems";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";
import { metaDataLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import { isEmpty } from "lodash";
import useSEO from "@/hooks/useSEO";

const Render = ( props:any ) => {

    useSEO(props.locals);

    return (<MNPG templates={props.pageTemplates} mapLayoutName={"MNPGGRP_004"} contentId={props.contentId} params={{contentId: props.contentId}} />)
}

const Search = ( props:TSearch ) => {
    console.log("Search.rendered: ", props);

    const { siteSettingPayload, webApplicationLanguageISOCode, _showLoader, _viewEvent } = useOutletContext<TOutletContext>();
    const [contentId] = useState(metaDataLanguageVersion("searchPageId", siteSettingPayload.languageVersions));
    const pageTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_004"});

    useEffect(() => { return () => { _showLoader(); }},[]);
    useEffect (() => { if (contentId) _viewEvent(contentId) }, [contentId])

    if ( !contentId || !pageTemplates || isEmpty(pageTemplates) ) return null;
    
    return (
        <Render pageTemplates={pageTemplates} contentId={contentId} locals={{language:webApplicationLanguageISOCode, type:"search-page", id:contentId}} />
    ) ;
}

export default Search
